import React, { useState } from "react";
import App from "../../App.css";

const Banner14 = ({
  banner1Heading,
  banner1Desc,
  image,
  flexReverse,
  button,
}) => {
  const flexItemReverse = flexReverse ? flexReverse : "";
  const [propShowData, setPropShowData] = useState(true);
  const [addPropShowData, setAddPropShowData] = useState(false);

  const propToggle = () => {
    setPropShowData(!propShowData);
    setAddPropShowData(false);
  };

  const addPropToggle = () => {
    setAddPropShowData(!addPropShowData);
    setPropShowData(false);
  };
  const styles = {
    propPopup: {
      backgroundColor: propShowData ? "#6CB4EE" : null,
      padding: 5,
    },

    addPropPopup: {
      backgroundColor: addPropShowData ? "#6CB4EE" : null,
      padding: 5,
    },
    content: (show) => ({
      maxHeight: show ? "500px" : "0",
      overflow: "hidden",
      transition: "max-height 0.5s  ",
    }),
  };
  return (
    <>
      {/* <section className='bg-grey' >
        <div className='container flex-column d-flex justify-content-center align-items-center pt-5'>
          <div className='container  align-items-center justify-content-center d-flex mt-5'>
            <div className="row">
              <div className="col-lg-8 col-md-12">
                <div className='image-container'>
                  <img className='col-lg-6' src='/img/realEstateImg-38.webp' alt='image' />
                  <img className='col-lg-6' src='/img/realEstateImg-39.webp' alt='image' />
                </div>
              </div>
              <div className="col-lg-4 col-md-12">
                <div className="m-2 align-items-center" style={{ borderBottom: '0.5px solid #D3D3D3', cursor: 'pointer' }}>
                  <div className={`propPopup ${propShowData ? 'active' : ''}`} onClick={propToggle} style={styles.propPopup}>
                    <button style={{ backgroundColor: '#FFAD01', color: 'white', fontSize: 17, height: 30, width: 30, border: 0, margin: 5 }}> {propShowData ? '-' : '+'}</button><span style={{ fontWeight: 'bold' }}>Property List</span>
                  </div>
                  {propShowData && (
                    <div className="content mt-2 mb-2 backColor">
                      <p>Real estate listings means a complete description of the house for sale, house for rent or any property such as individual house details such as apartments, home, commercial building. A buyer’s agent represents the interests of the home buyer in a real estate transaction, and works to help them find their new home and negotiate a fair price.</p>
                    </div>
                  )}
                </div>
                <div className="m-2 align-items-center" style={{ borderBottom: '0.5px solid #D3D3D3', cursor: 'pointer' }}>
                  <div className={`addPropPopup ${addPropShowData ? 'active' : ''}`} onClick={addPropToggle} style={styles.addPropPopup}>
                    <button style={{ backgroundColor: '#FFAD01', color: 'white', fontSize: 17, height: 30, width: 30, border: 0, margin: 5 }}>{addPropShowData ? '-' : '+'}</button><span style={{ fontWeight: 'bold' }}>Add Property</span>
                  </div>
                  {addPropShowData && (
                    <div className="content mt-2 mb-2 backColor">
                      <p>In this screen, administrators can add various details e.g., properties’ basic information, number of rooms & bedrooms, amenities, preferred tenants, furniture, equipment, required services, electricity, property description & upload pictures etc.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* ***** Changed One *****  */}
      <section className="bg-grey d-flex justify-content-center">
        <div className="container-fluid flex-column d-flex justify-content-center align-items-center pt-5">
          <div
            className="align-items-center justify-content-center d-flex mt-5"
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <div className="row px-lg-5 px-sm-0">
              <div className="col-lg-7 col-md-12">
                <div className="image-container">
                  <img
                    className="col-lg-6"
                    src="/img/realEstateImg-38.webp"
                    alt="image"
                  />
                  <img
                    className="col-lg-6"
                    src="/img/realEstateImg-39.webp"
                    alt="image"
                  />
                </div>
              </div>
              <div className="col-lg-5 col-md-12">
                <div
                  className="m-2 align-items-center"
                  style={{
                    borderBottom: "0.5px solid #D3D3D3",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className={`propPopup ${propShowData ? "active" : ""}`}
                    onClick={propToggle}
                    style={styles.propPopup}
                  >
                    <button
                      style={{
                        backgroundColor: "#FFAD01",
                        color: "white",
                        fontSize: 17,
                        height: 30,
                        width: 30,
                        border: 0,
                        margin: 5,
                      }}
                    >
                      {propShowData ? "-" : "+"}
                    </button>
                    <span style={{ fontWeight: "bold" }}>Property List</span>
                  </div>
                    <div className="content mt-2 mb-2 backColor"
                    style={styles.content(propShowData)}
                    >
                      <p style={{ fontWeight: "450", fontSize: "1.2rem" }}>
                        Real estate listings means a complete description of the
                        house for sale, house for rent or any property such as
                        individual house details such as apartments, home,
                        commercial building. A buyer’s agent represents the
                        interests of the home buyer in a real estate
                        transaction, and works to help them find their new home
                        and negotiate a fair price.
                      </p>
                    </div>
                </div>
                <div
                  className="m-2 align-items-center"
                  style={{
                    borderBottom: "0.5px solid #D3D3D3",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className={`addPropPopup ${
                      addPropShowData ? "active" : ""
                    }`}
                    onClick={addPropToggle}
                    style={styles.addPropPopup}
                  >
                    <button
                      style={{
                        backgroundColor: "#FFAD01",
                        color: "white",
                        fontSize: 17,
                        height: 30,
                        width: 30,
                        border: 0,
                        margin: 5,
                      }}
                    >
                      {addPropShowData ? "-" : "+"}
                    </button>
                    <span style={{ fontWeight: "bold" }}>Add Property</span>
                  </div>
                    <div className="content mt-2 mb-2 backColor"
                    style={styles.content(addPropShowData)}
                    >
                      <p style={{ fontWeight: "450", fontSize: "1.2rem" }}>
                        In this screen, administrators can add various details
                        e.g., properties’ basic information, number of rooms &
                        bedrooms, amenities, preferred tenants, furniture,
                        equipment, required services, electricity, property
                        description & upload pictures etc.
                      </p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner14;
